@if (goTo=='signin') {
  <app-signin (callbackFunction)="callbackSignin()" (goTo)="_goTo($event)"></app-signin>
}
@if (goTo=='signup') {
  <app-signup (callbackFunction)="callbackSignup()" (goTo)="_goTo($event)"></app-signup>
}
@if (goTo=='reset') {
  <app-forgot-password (callbackFunction)="callbackSignup()" (goTo)="_goTo($event)"></app-forgot-password>
}